module.exports = __webpack_public_path__ + "static/Charles Video Page-c00a1d9bfe783e79821a216051856d6f.jpg";